
export class UserIdModel {
  userId: string =''
}

